export default __webpack_public_path__ + "static/media/my-bookmark.94a42123.svg";